import './BlockSubtitle.css';

function BlockSubtitle(props) {
 
  return (
    <div id="BlockSubtitle">
      {props.children}
    </div>

  );
}

export default BlockSubtitle;
